import React, { useEffect, useMemo } from "react";

import { ProductPickerContext } from "@src/components/MainApp/SharedProductPicker/ProductPickerContext";
import { useSelector } from "@src/store";
import {
  getProductPickerData,
  getProductPickerExcludedProductIds,
  getProductPickerFilters,
  getProductPickerSearch,
  PRODUCT_PICKER_PAGE_SIZE,
} from "@src/store/slices/productPicker";
import { ProductPickerProductDataSource } from "@src/store/slices/productPicker/util/ProductPickerProductDataSource";

interface ProductPickerProviderProps {
  children?: React.ReactNode;
  allowIgProducts?: boolean;
  loadVariants?: boolean;
}

export const ProductPickerProvider = ({
  children,
  allowIgProducts,
  loadVariants,
}: ProductPickerProviderProps) => {
  const filters = useSelector(getProductPickerFilters);
  const search = useSelector(getProductPickerSearch);
  const data = useSelector(getProductPickerData);
  const excludedProductIds = useSelector(getProductPickerExcludedProductIds);

  const context = useMemo(() => {
    return {
      dataSource: new ProductPickerProductDataSource({
        allowIgProducts,
        loadVariants: loadVariants,
      }),
      loadVariants,
    };
  }, [allowIgProducts, loadVariants, data?.type]);

  context.dataSource.setExcludedProductIds(excludedProductIds);
  context.dataSource.setFilters(filters);
  context.dataSource.setSearch(search);

  useEffect(() => () => context.dataSource.clear(), []);

  return (
    <ProductPickerContext.Provider value={context}>
      {children}
    </ProductPickerContext.Provider>
  );
};
